/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Enum_Pbs_Fb125Inputs */

const en__field_enum_pbs_fb125 = /** @type {(inputs: _Field_Enum_Pbs_Fb125Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`F 12 Faculty of Computer Science and Mathematics`)
};

const de__field_enum_pbs_fb125 = /** @type {(inputs: _Field_Enum_Pbs_Fb125Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`FB 12 Informatik und Mathematik`)
};

/**
* | output |
* | --- |
* | "F 12 Faculty of Computer Science and Mathematics" |
*
* @param {_Field_Enum_Pbs_Fb125Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_enum_pbs_fb125 = /** @type {((inputs?: _Field_Enum_Pbs_Fb125Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Enum_Pbs_Fb125Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_enum_pbs_fb125(inputs)
	return de__field_enum_pbs_fb125(inputs)
});
export { _field_enum_pbs_fb125 as "_field_enum_PBS_FB12" }